import styled from 'styled-components';

const PostItemStyle = styled.div`
	--sizeImage: 54.6%;
	--borderRadius: var(--sp4x);
	--distancePadLR: var(--sp6x);
	--distancePadTB: var(--sp6x);
	--descriptionInfoDistance: var(--sp6x);
	--distanceTitleDescription: var(--sp4x);

	height: 100%;

	.wrapper-link {
		height: 100%;
		display: flex;
		flex-direction: column;
		border: 1px solid var(--neutral600);
		overflow: hidden;
		border-radius: var(--borderRadius);
		transition: var(--trTime) ease-out;
	}

	.image-cont {
		--proportion: var(--sizeImage);
	}

	.wrapper-block {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: var(--distancePadTB) var(--distancePadLR);
	}

	.text-title,
	.text-description {
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.wrapper-text {
		display: flex;
		flex-direction: column;
		gap: var(--distanceTitleDescription);
	}

	.wrapper-data-info {
		display: flex;
		justify-content: space-between;
		margin-top: var(--descriptionInfoDistance);
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.wrapper-link {
				&:hover {
					border-color: var(--mainColor);
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--borderRadius: var(--sp3x);
		--distancePadLR: var(--sp5x);
		--distancePadTB: var(--sp5x);
		--descriptionInfoDistance: var(--sp4x);
		--distanceTitleDescription: var(--sp3x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--borderRadius: var(--sp2-5x);
		--distancePadLR: var(--sp4x);
		--distancePadTB: var(--sp4x);
		--descriptionInfoDistance: var(--sp3x);
		--distanceTitleDescription: var(--sp3x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--sizeImage: 55.3%;
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--borderRadius: var(--sp2x);
		--distancePadLR: var(--sp3x);
		--distancePadTB: var(--sp3x);
		--descriptionInfoDistance: var(--sp2x);
		--distanceTitleDescription: var(--sp2x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--borderRadius: var(--sp1-5x);
		--distancePadLR: var(--sp2x);
		--distancePadTB: var(--sp2x);
		--descriptionInfoDistance: var(--sp2x);
		--distanceTitleDescription: var(--sp1x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--sizeImage: 56.596%;
		--borderRadius: var(--sp2x);
		--distanceTitleDescription: var(--sp2x);
	}
`;
export default PostItemStyle;
